module.exports = __webpack_public_path__ + "static/media/close-keyplan.fe1dbabb.svg";